module.exports = __webpack_public_path__ + "static/emotional-equations-f1ee5ca41efa457ffd41b88109872852.jpg";